function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { textsDefaul, envConfig, TYPE_CHANGE_METADA, TAG_QUERIES, DEFAULT_TPL_FIELDS, ALL_TABLES_OPTION, TYPSE_SENSE_TYPE_OBJECTS, ACCESS_TYPE_FLOW } from '@/js/constants';
export default {
  name: 'OrganizacionComponent',
  props: {
    value: {
      required: true
    },
    show_all: {
      default: true,
      required: false
    },
    show_only: {
      default: false,
      required: false
    },
    get_code: {
      default: false,
      required: false
    },
    custom_orgs: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    view: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      model: this.value,
      isDisabled: this.disabled
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['orgs'])), {}, {
    processd_list_domains: function processd_list_domains() {
      var _this = this;
      var list_domains = [];
      var list_orgs = this.custom_orgs.length > 0 ? this.custom_orgs : this.orgs;
      list_orgs.forEach(function (x) {
        if (_this.show_only) {
          if (x.domain == window.userInfo.domain) {
            if (list_domains.filter(function (x) {
              return x.domain == window.userInfo.domain;
            }).length == 0) list_domains.unshift({
              text: x.alias,
              value: _this.get_code ? x.code : x.domain,
              domain: x.domain
            });
          }
        } else {
          list_domains.unshift({
            text: x.alias,
            value: _this.get_code ? x.code : x.domain,
            domain: x.domain
          });
        }
      });
      list_domains.sort(function (a, b) {
        return a.text.localeCompare(b.text);
      });
      if (this.show_all) {
        list_domains.unshift({
          text: this.traductor('common.all_a'),
          value: ALL_TABLES_OPTION,
          domain: ''
        });
      }
      console.log(list_domains);
      return list_domains;
    }
  }),
  created: function created() {},
  methods: {
    emitChange: function emitChange() {
      console.log(this.model);
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    }
  },
  watch: {
    disabled: function disabled(newVal) {
      this.isDisabled = newVal;
    },
    model: function model(newValue) {
      console.log("aqui-------------------", newValue);
      this.$emit('input', newValue.value ? newValue.value : newValue);
      this.$emit('change');
    },
    value: function value(newValue) {
      this.model = newValue.value ? newValue.value : newValue;
    }
  }
};